import { getBrowserClient } from '@/lib/integrations/supabase/client';
import type { Alert } from '@/lib/integrations/supabase/types';
import * as Sentry from "@sentry/nextjs";

// ============================================================================
// Alert Queries
// ============================================================================

/**
 * Get open alerts for a business.
 */
export async function getOpenAlerts(businessId: string): Promise<Alert[]> {
  const supabase = getBrowserClient();

  const { data, error } = await supabase
    .from('alerts')
    .select('*')
    .eq('business_id', businessId)
    .eq('status', 'open')
    .order('created_at', { ascending: false });

  if (error) {
    Sentry.captureException(error);
    throw error;
  }

  return data || [];
}

/**
 * Get alert count for a business.
 */
export async function getAlertCount(businessId: string): Promise<number> {
  const supabase = getBrowserClient();

  const { count, error } = await supabase
    .from('alerts')
    .select('*', { count: 'exact', head: true })
    .eq('business_id', businessId)
    .eq('status', 'open');

  if (error) {
    Sentry.captureException(error);
    throw error;
  }

  return count || 0;
}

/**
 * Resolve an alert.
 */
export async function resolveAlert(alertId: string): Promise<void> {
  const supabase = getBrowserClient();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { error } = await (supabase
    .from('alerts') as any)
    .update({
      status: 'resolved',
      resolved_at: new Date().toISOString(),
    })
    .eq('id', alertId);

  if (error) {
    Sentry.captureException(error);
    throw error;
  }
}

